import { TextCaption } from '@carboncopyco/ui';
import type React from 'react';

export interface RuleOptionButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export const RuleOptionButton = ({
  label,
  icon,
  onClick,
}: RuleOptionButtonProps) => {
  return (
    <div
      role="button"
      className="text-ds-primary-300 border border-ds-natural-150 rounded-md hover:bg-ds-natural-100 flex flex-col items-center justify-center gap-2.5  h-ds-21 cursor-pointer w-ds-20"
      onClick={onClick}
    >
      {icon}
      <TextCaption
        label={label}
        color="text-ds-natural-600"
      />
    </div>
  );
};
